export const PRODUCT_CATALOG_CONTEXT_STORAGE_KEY = 'product_catalog_return_context'
export const PENDING_CART_ADD_STORAGE_KEY = 'product_catalog_pending_cart_add'

export const saveProductCatalogContext = (context) => {
    try {
        window.sessionStorage.setItem(PRODUCT_CATALOG_CONTEXT_STORAGE_KEY, JSON.stringify(context))
    } catch (error) {
        // The catalog remains usable when session storage is unavailable.
    }
}

export const readProductCatalogContext = () => {
    try {
        const rawContext = window.sessionStorage.getItem(PRODUCT_CATALOG_CONTEXT_STORAGE_KEY)
        return rawContext ? JSON.parse(rawContext) : null
    } catch (error) {
        return null
    }
}

export const clearProductCatalogContext = () => {
    try {
        window.sessionStorage.removeItem(PRODUCT_CATALOG_CONTEXT_STORAGE_KEY)
    } catch (error) {
        // The catalog remains usable when session storage is unavailable.
    }
}

export const savePendingCartAdd = (intent) => {
    try { window.sessionStorage.setItem(PENDING_CART_ADD_STORAGE_KEY, JSON.stringify({ ...intent, createdAt: Date.now() })) } catch (error) {}
}

export const readPendingCartAdd = () => {
    try {
        const raw = window.sessionStorage.getItem(PENDING_CART_ADD_STORAGE_KEY)
        const intent = raw ? JSON.parse(raw) : null
        return intent && Date.now() - Number(intent.createdAt || 0) < 15 * 60 * 1000 ? intent : null
    } catch (error) { return null }
}

export const clearPendingCartAdd = () => {
    try { window.sessionStorage.removeItem(PENDING_CART_ADD_STORAGE_KEY) } catch (error) {}
}
